import React from "react";
import { Link } from "react-router-dom";
import "./BookList.css";

const Book = ({
  id,
  title,
  cover_img,
  author_name,
  publishedYear,
  editions,
}) => {
  return (
    <div className="book-item flex flex-column flex-sb">
      <div className="book-item-img">
        <img src={cover_img} alt={title} />
      </div>
      <div className="book-item-info text-center">
        <Link to={`/book/${id}`}>
          <div className="book-item-info-item title fw-7 fs-18">
            <span>{title}</span>
          </div>
        </Link>

        <div className="book-item-info-item author fs-15">
          <span className="text-capitalize fw-7">Author: </span>
          {/* used the .join() to add comma and white space to author names more than one. */}
          {/* Ensure author_name is an array before using join */}
          <span>
            {Array.isArray(author_name) ? author_name.join(", ") : author_name}
          </span>
        </div>

        <div className="book-item-info-item edition-count fs-15">
          <span className="text-capitalize fw-7">Total Editions: </span>
          <span>{editions}</span>
        </div>

        <div className="book-item-info-item pub-year fs-15">
          <span className="text-capitalize fw-7">Year of publication: </span>
          <span className="">{publishedYear}</span>
        </div>
      </div>
    </div>
  );
};

export default Book;
